import axios from "axios";
import {AppDispatch, RootState} from "../../app/store";
import {showErrorToast} from "../../utils/showToast";
import {parseLabelObject} from "../Header/ExportActions";
import {GetAllCounterData} from "../CompanyDataTables/TablesActions";
import i18n from "i18next";

export const FillData = (tags: string[], companyId: number, toPng: boolean = false, specimen: boolean = true) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      let integrationUrl = getState().auth.rights.find((c) => c.companyId === companyId)?.integrationUrl;
      let url = `api/Fill/${companyId}`;
      let integrationTags: string[] = [];
      let filteredTags: string[] = [];

      if (integrationUrl) {
        try {
          if(toPng && !specimen){
            integrationUrl = integrationUrl + `?fillOnly=false`;
          }
          const response = await axios.post(integrationUrl, tags);
          if (response.data.msg) {
            showErrorToast(i18n.t("error"), i18n.t("integration_url") + i18n.t(response.data.msg));
          }
          integrationTags = response.data.data;
          filteredTags = filterTags(integrationTags, tags);
        } catch (error) {
          //console.error("Error integration url:", error);
          showErrorToast(i18n.t("error"), i18n.t("integration_url_err"));
          filteredTags = tags;
        }
      } else {
        filteredTags = tags;
      }

      try {
        const finalResponse = await axios.post(url, filteredTags);
        if (finalResponse.data.success) {
          return finalResponse.data.datatags; // response.data.data - string[] for label generation
        } else {
          showErrorToast(i18n.t("error"), i18n.t(finalResponse.data.msg));
          return null;
        }
      } catch (error) {
        //console.error("Error during fill request:", error);
        showErrorToast(i18n.t("error"), i18n.t("fill_fail_err"));
        return null;
      }
    } catch (error) {
      showErrorToast(i18n.t("error"), i18n.t("fill_fail_err"));
      return null;
    }
  };
};

const filterTags = (integrationTags: string[], tags: string[]) => {
  const filteredTags: string[] = [];
  for (let i = 0; i < tags.length; i += 2) {
    const tag = tags[i];
    const value = tags[i + 1];
    const tagIndex = integrationTags.indexOf(tag);
    if (tagIndex !== -1 && tagIndex + 1 < integrationTags.length) {
      filteredTags.push(integrationTags[tagIndex], integrationTags[tagIndex + 1]);
    } else {
      filteredTags.push(tag, value);
    }
  }
  return filteredTags;
};

export const ExportPngWithData = (tags: string[], specimen: boolean, companyId: number, isPrint: boolean = false, recid: number = -1) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      const {labelItems, labelParams} = getState().labelEdit.present;
      const label = parseLabelObject(labelItems, labelParams);

      const response = await axios.post(
          `api/Fill/Png/${companyId}`,
          { label, tags, specimen, recid, isPrint },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );
      
      if (response.status === 200) {
        const blob = new Blob([response.data], {type: "image/png"});
        dispatch(GetAllCounterData(companyId));
        return blob;
      }
    } catch (error) {
      showErrorToast(i18n.t("export_png_error"), i18n.t("not_found_error"));
      return null;
    }
    return null;
  };
};

export const ExportToIntegrationUrl = (tags: string[], specimen: boolean, companyId: number, isPrint: boolean = false, recid: number = -1) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    const {labelItems, labelParams} = getState().labelEdit.present;
    const label = parseLabelObject(labelItems, labelParams);
    const integrationUrl = getState().auth.rights.find((c) => c.companyId === companyId)?.integrationUrl;

    if (!integrationUrl) {
      return null;
    }

    try {
      const response = await axios.post(
        "api/Fill/GetTagsForExport/" + companyId,
        { label, tags, specimen, recid, isPrint }
      );
      if (response.status === 200 && response.data.success) {
       const tagsForExport = response.data.data;
       const integrationResponse = await axios.post(integrationUrl + "/png",
        { label, tags: tagsForExport, specimen, recid, isPrint },
        {
          headers: {
            "Content-Type": "application/json",
          },
          //responseType: "blob",
        }
       );
       if (integrationResponse.status === 200 && integrationResponse.data?.success) {
        const { fileContent } = integrationResponse.data;

        if (!fileContent) {
          showErrorToast(i18n.t("error"), i18n.t("template_not_found"));
          return null;
        }
        const byteString = atob(fileContent);
        const byteArray = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
          byteArray[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: "image/png" });
        return blob;
        } else {
        showErrorToast(i18n.t("error"), integrationResponse.data?.msg || "Unknown error");
        return null;
      }}
    } catch (error:any) {
      //console.error("Error during export request:", error);
      showErrorToast(i18n.t("export_png_error"), i18n.t("not_found_error"));
      return null;
    }
    return null;
  }
};